import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "EH_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#EH_svg__a)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 0h32v24H0V0z", fill: "#F7FCFF" }), /* @__PURE__ */ e.createElement("path", { d: "M0 0v8h32V0H0z", fill: "#272727" }), /* @__PURE__ */ e.createElement("path", { d: "M0 16v8h32v-8H0z", fill: "#5EAA22" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M0 0l16 12L0 24V0zM21.688 15.477s-2.274-1.374-2.274-3.646 2.274-3.467 2.274-3.467c-1.018-.646-4.548.276-4.548 3.54 0 3.266 3.497 3.869 4.548 3.573zm1.841-4.164l-1.324-1.24.457 1.583-1.28.607 1.573.512.683 1.715.299-1.587 1.554.343-1.176-1.148.398-1.226-1.184.441z",
      fill: "#E31D1C"
    }
  ))
);
export {
  l as default
};
